import { cn } from '@qr-front/ui/utils'
import { subExpiredDialogAtom } from 'features/library/client'
import { useAtomValue, useSetAtom } from 'jotai'
import { useTranslations } from 'next-intl'

import { TQrDesign } from '@/generator/client'
import { userAtom } from '@/global-state'
import { getTrialRemainingTime, isUserOnFreeTrial } from '@/utils'

// TODO: add path alias for utils
// TODO: expose QR content types from generator
import { previewColDef } from '../../columnsConfig'
import { duplicatedQrHighlightAtom } from '../../tableState'
import { useCellValue } from '../../utils/cellValue'
import {
	CreateDate,
	Status,
	Type,
	VerticalSeparator,
	WebsiteUrl,
} from '../commonElements'
import { PreviewCell } from '../PreviewCell'
import { MobileHeader } from './MobileHeader'
import { MobileScans } from './MobileScans'

const ScansAndStatusRow = () => (
	<div className="flex items-center gap-4">
		<MobileScans />
		<VerticalSeparator />
		<Status />
	</div>
)

export const Details = () => (
	<div className="type-body-small flex flex-col justify-center gap-1">
		<Type />
		<ScansAndStatusRow />
		<CreateDate />
	</div>
)

export const TableRowMobile = ({ index }: { index: number }) => {
	const t = useTranslations()
	const user = useAtomValue(userAtom)
	const userTrial = getTrialRemainingTime(
		user?.createdAt,
		user?.flowData?.freeDaysQuota,
	)
	const isOnTrial = isUserOnFreeTrial(user) && !userTrial.expired

	const setTrialExpiredDialogAtom = useSetAtom(subExpiredDialogAtom)
	const highlightId = useAtomValue(duplicatedQrHighlightAtom)

	const qrItem = useCellValue(previewColDef)
	const { id, updatedAt, qrDesign, content, uri, disabled } = qrItem

	const isRowAtFirstIndex = index === 0
	const shouldShowTrial = isRowAtFirstIndex && isOnTrial

	return (
		<>
			{shouldShowTrial && (
				<button
					onClick={() => setTrialExpiredDialogAtom(true)}
					className="type-body-small flex w-full items-center justify-center rounded-t-10 bg-green py-1 text-white tablet:hidden"
				>
					{t('dashboard__qr_codes__free_trial')}
				</button>
			)}
			<div
				className={cn(
					'flex max-w-[calc(100dvw-40px)] flex-col gap-4 bg-white p-4 tablet:hidden',
					shouldShowTrial ? 'rounded-b-10 tablet:rounded-10' : 'rounded-10',
					isRowAtFirstIndex &&
						id === highlightId &&
						'ring ring-inset ring-blue duration-300 animate-in fade-in zoom-in-90',
				)}
			>
				<MobileHeader qrItem={qrItem} />
				<div className="flex gap-4">
					<PreviewCell
						id={id}
						updatedAt={updatedAt}
						qrDesign={qrDesign as TQrDesign}
						content={content}
						uri={uri}
						disabled={disabled}
					/>
					<Details />
				</div>
				<WebsiteUrl className="max-w-full truncate" />
			</div>
		</>
	)
}
